import { useTranslation } from '@axo/shared/i18n';
import { Icon } from '@axo/ui-core/components/Icon';
import { InfoCard } from '@axo/ui-feature/components/InfoCard/InfoCard';
import { FormProvider, useForm } from 'react-hook-form';
import { Form, Navigation } from '../../../../../components';
import { useAxoFormContext } from '../../../../../context/AxoForm/AxoForm';
import useInitiatedTracking from '../../../../../hooks/tracking/useInitiatedTracking';
import { DenmarkFormData } from '../../FormData.dk.types';
import { FallbackPurposeFormGroup } from '../../shared/FallbackPurposeFormGroup';
import { LoanOverviewGroup } from './LoanOverviewGroup';

export const LoanOverview = () => {
  const { t } = useTranslation();

  const { onChange, onSubmit } = useAxoFormContext<DenmarkFormData>();

  const form = useForm();

  const {
    formState: { touchedFields, isSubmitting },
  } = form;

  useInitiatedTracking({
    shouldTriggerOnInitiated: Object.keys(touchedFields).length > 0,
  });

  return (
    <FormProvider {...form}>
      <Form onSubmit={onSubmit} onChange={onChange}>
        <InfoCard
          description={t('InfoCard.description')}
          title={t('InfoCard.title')}
          icon={<Icon name="piggy-bank-solid" />}
        />
        <LoanOverviewGroup />

        <FallbackPurposeFormGroup />

        <Navigation.Continue loading={isSubmitting}>
          {t('next')}
        </Navigation.Continue>
      </Form>
    </FormProvider>
  );
};
